

export const PersistenceKeys = {
    AUTHENTICATION_TOKEN: 'AUTH_TOKEN',
    AUTHENTICATION_REFRESH_TOKEN: 'AUTH_REFRESH_TOKEN',
}